import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useVideoLocationOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isVideoLocationLoading,
    data: videoLocations,
    refetch: refetchVideoLocation,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch video location options'),
    mapByKey: 'legacy_id',
    optionType: OptionsType.LINEARVIDEO_LOCATION,
    queryOptions,
  });

  return {
    isVideoLocationLoading,
    refetchVideoLocation,
    videoLocations,
  };
}
